import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import "./SubscriptionSuccess.css";

export default function SubscriptionSuccess() {
  const navigate = useNavigate();

  const handleGoToCourses = () => {
    navigate("/courses");
  };

  return (
    <div className="subscription-success-page">
      <Header />
      <div className="subscription-success-container">
        <h1>Спасибо за подписку</h1>
        
        <div className="checkmark-icon">
        </div>

        <button className="go-to-courses-btn" onClick={handleGoToCourses}>
          К выбору курса
        </button>
      </div>
    </div>
  );
}
